import React from 'react'
import '../../../css/app.css'

const Tables = ({ activeTab, tableData }) => {
    return (
        <div>
            {tableData && <table className='dashboard_table'>
                <tr className='table_row'>
                    <th className='Sl_no'>S.No.</th>
                    {activeTab === "lender" && <th className='leder_name'>Lender</th>}
                    {/* {activeTab === "program" && <th className='leder_name'>Program</th>} */}
                    {/* {activeTab === "co_lending" && <th className='program_name'>Program</th>} */}
                    {(activeTab === "lender" || activeTab === "program") && <>
                        <th>Case Assigned </th>
                        <th>Pending</th>
                        <th>Rejected</th>
                        <th>Sanctioned</th>
                        <th>Disbursal Pending</th>
                        <th>Disbursal Rejected</th>
                        <th>Disbursed</th>
                    </>}
                    {/* {activeTab === "co_lending" &&
                        <>
                            <th className={'option_data' } >Option 1</th>
                            <th className={'option_data' } >option 1 (PS)</th>
                            <th className={'option_data' } >Option 2</th>
                            <th className={'option_data' } >DA</th>
                        </>
                    } */}
                </tr>
                {tableData.map((ele, ind) => {
                    return (
                        <>
                            <tr className='table_data'>
                                <td className='Sl_no'>{(ind + 1)}</td>
                                {activeTab === "lender" && <td className={'co_landing_data_heading' } >{ele?.id}</td>}
                                {/* {(activeTab === "program" || activeTab === "co_lending") && <>
                                    <td className={'co_landing_data_heading' }  >{ele?.id} </td>
                                </>} */}
                                {(activeTab === "program" || activeTab === "lender") && <>
                                    <td className={'co_landing_data' }>{ele?.lead_assigned}</td>
                                    <td className={'co_landing_data' }>{ele?.lender_pending}</td>
                                    <td className={'co_landing_data' }>{ele?.sanction_rejected}</td>
                                    <td className={'co_landing_data' }>{isNaN(ele?.sanction_approved + ele?.pre_sanction_approved)? 0 :ele?.sanction_approved + ele?.pre_sanction_approved}</td>
                                    <td className={'co_landing_data' }>{ele?.disbursal_pending}</td>
                                    <td className={'co_landing_data' }>{ele?.disbursal_rejected}</td>
                                    <td className={'co_landing_data' }>{ele?.disbursal_portfolio + ele?.disbursal_lender_decision}</td>
                                </>
                                }
                                {/* {activeTab === "co_lending" && <>
                                    <td className='co_landing_data'>{ele?.option_1}</td>
                                    <td className='co_landing_data'>{ele?.['option_1_(PS)']}</td>
                                    <td className='co_landing_data'>{ele?.option_2}</td>
                                    <td className='co_landing_data'>{ele?.DA}</td>
                                </>} */}
                            </tr>
                        </>
                    )
                })}
            </table>}
        </div >
    )
}

export default Tables